// Hotfix for Scroll To anchor with lazy loading bug / issues
// TODO : maybe Remove this file when the issue is fixed in the core with aspect-ratio etc
document.addEventListener("DOMContentLoaded", (event) => {
    const scroll2hashTimeOut = setTimeout(() => {

        const hashLink = location.hash.slice(1);
        if (hashLink && hashLink.length > 0) {
            (document.getElementById(hashLink)).scrollIntoView({
                behavior: 'smooth',
            });

        }
    }, 1500);
});

